import { categories, ctaButtons, MAIN_SITE_URL } from "@/utils/constants";

const footerArticleLinks = [
  { label: "Poradnik Kakobuy Spreadsheet", href: "/artykul/kakobuy-spreadsheet-polska" },
  { label: "Czy Kakobuy jest bezpieczny?", href: "/artykul/czy-kakobuy-jest-bezpieczny" },
  { label: "Kakobuy Shipping Polska", href: "/artykul/kakobuy-shipping-polska" },
  { label: "Kakobuy Finds Polska", href: "/artykul/kakobuy-finds-polska" },
  { label: "Kakobuy Opinie", href: "/artykul/kakobuy-opinie" },
  { label: "Kakobuy Haul Polska", href: "/artykul/kakobuy-haul-polska" },
  { label: "Jak korzystać z Kakobuy", href: "/artykul/kakobuy-jak-korzystac" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:max-w-sm">
            <a href="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-foreground-900">
                Kakobuy<span className="text-accent-500">Polska</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Największa baza Kakobuy Spreadsheet dla polskich użytkowników. Pomagamy szybciej znajdować produkty, analizować oferty i bezpiecznie korzystać z Kakobuy.
            </p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              Odwiedź Kakobuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">Kategorie</h4>
              <ul className="space-y-2">
                {categories.slice(0, 7).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">Więcej kategorii</h4>
              <ul className="space-y-2">
                {categories.slice(7, 14).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">Poradniki</h4>
              <ul className="space-y-2">
                {footerArticleLinks.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">Linki</h4>
              <ul className="space-y-2">
                <li>
                  <a href="/#bezpieczenstwo" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                    Bezpieczeństwo
                  </a>
                </li>
                {ctaButtons.map((btn) => (
                  <li key={btn.label}>
                    <a
                      href={btn.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                    >
                      {btn.label}
                    </a>
                  </li>
                ))}
                <li>
                  <a href="/artykul/kakobuy-shoes-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                    Shoes Spreadsheet
                  </a>
                </li>
                <li>
                  <a href="/artykul/kakobuy-hoodie-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                    Hoodie Spreadsheet
                  </a>
                </li>
                <li>
                  <a href="/artykul/kakobuy-lista-produktow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                    Lista Produktów
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} KakobuyPolska. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <a href="/#privacy" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
              Polityka prywatności
            </a>
            <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
              Kakobuy Spreadsheet
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}